import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_CONFIG_DEFINITION } from '@softline/dynamic';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { ProduktionsauftragDetailComponent } from './components/produktionsauftrag-detail/produktionsauftrag-detail.component';
import { default as extendedFilterDefinition } from './definitions/extendedfilter.definition.json';
import { default as filterDefinition } from './definitions/simplefilter.definition.json';
import {
  SOFTLINE_CONFIG_PRODUKTIONSAUFTRAG,
  SOFTLINE_CONFIG_PRODUKTIONSAUFTRAG_DETAIL_TEMPLATE,
  SOFTLINE_DEFINITION_PRODUKTIONSAUFTRAG_FILTER,
  SOFTLINE_DEFINITION_PRODUKTIONSAUFTRAG_FILTER_EXTENDED,
  SOFTLINE_PERMISSION_PRODUKTIONSAUFTRAG,
} from './produktionsauftrag.shared';
import { produktionsauftragRoutes } from './produktionsauftrag.routes';
import { provideProduktionsauftragGlobals } from './produktionsauftrag.globals';

export function provideProduktionsauftragModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'produktionsauftrag',
        title: 'Produktionsaufträge',
        icon: 'fa-regular fa-clipboard-list',
        route: '/produktionsauftrag',
        permission: SOFTLINE_PERMISSION_PRODUKTIONSAUFTRAG,
        group: getModuleGroupByName('Produktion'),
      },
      withSoftAppsModuleRoutes({ app: produktionsauftragRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
    ...provideProduktionsauftragGlobals(),
  ];
}

export const produktionsauftragProviders: Array<Provider | EnvironmentProviders> = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'produktionsauftrag',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Produktionsaufträge',
      icon: 'fa-regular fa-clipboard-list',
      route: '/produktionsauftrag',
      permission: SOFTLINE_PERMISSION_PRODUKTIONSAUFTRAG,
      group: getModuleGroupByName('Produktion'),
    });
  }),
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_PRODUKTIONSAUFTRAG_FILTER,
      definition: filterDefinition,
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_PRODUKTIONSAUFTRAG_FILTER_EXTENDED,
      definition: extendedFilterDefinition,
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_PRODUKTIONSAUFTRAG_DETAIL_TEMPLATE,
    useValue: ProduktionsauftragDetailComponent,
  },
  {
    provide: SOFTLINE_CONFIG_PRODUKTIONSAUFTRAG,
    useValue: {
      showKundenInfo: true,
    },
  },
];
